<template>
  <div :class="{ 'car-comparison-cart--active': showCarComparisonFooter, container: tabletUp }">
    <NavigationHeader />

    <slot name="page-hero"></slot>

    <div class="page-layout">
      <slot name="page-title" v-if="moduleTitle">
        <div>
          <h1 class="module-title" v-text="moduleTitle" />
          <h2 v-if="moduleSubtitle" class="module-subtitle" v-text="moduleSubtitle" />
        </div>
        <ShareCopy />
      </slot>

      <!-- Default page content slot -->
      <slot />
    </div>
  </div>

  <div v-if="withSearchModal">
    <MakeModelModal v-if="showMakeModelModal" :modal-to-display-on-load="modalToDisplayOnLoad" @close-modal="modalStore.closeShowMakeModelModal" />
  </div>

  <div v-if="withComparisonCart">
    <CarComparisonFooter v-model="showCarComparisonFooter" v-if="showCarComparisonFooter" />
  </div>

  <div v-if="withMobileInfoOverlay">
    <CarComparisonMobileOverlay v-model="showCarComparisonMobileInfoOverlay" />
  </div>

  <!-- WIP: This is just a demo of a slide out modal with vue-final-modal
         I wil revisit this in a later tech debt cleanup sprint. -->
  <!-- <button @click="() => open()">Open Slide Out Modal</button> -->
</template>

<script setup lang="ts">
import { useModalStore } from '../foundation/stores/modalStore';
import { useCarComparisonStore } from '../foundation/stores/carComparisonStore';
import { storeToRefs } from 'pinia';
import { useContentStore } from '../foundation/stores/contentStore';

import NavigationHeader from '../components/search/NavigationHeader.vue';
import ShareCopy from '../components/share/ShareCopy.vue';
import MakeModelModal from '../components/modals/MakeModelModal.vue';
import CarComparisonFooter from '../components/car-comparison/CarComparisonFooter.vue';
import CarComparisonMobileOverlay from '../components/car-comparison/CarComparisonMobileOverlay.vue';
import { useBreakpoints } from '@vueuse/core';
import { APP_BREAKPOINTS } from '../foundation/appConstants';
import { onMounted } from 'vue';

const props = defineProps({
  moduleTitle: {
    type: String,
    required: false,
    default: '',
  },
  moduleSubtitle: {
    type: String,
    required: false,
    default: '',
  },
  withComparisonCart: {
    type: Boolean,
    default: true,
  },
  withSearchModal: {
    type: Boolean,
    default: true,
  },
  withMobileInfoOverlay: {
    type: Boolean,
    default: false,
  },
});

const modalStore = useModalStore();
const { showMakeModelModal, modalToDisplayOnLoad } = storeToRefs(modalStore);
const breakpoints = useBreakpoints(APP_BREAKPOINTS);
const comparisonStore = useCarComparisonStore();
const { showCarComparisonFooter, showCarComparisonMobileInfoOverlay } = storeToRefs(comparisonStore);

const contentStore = useContentStore();
contentStore.fetchFuelPrices();
contentStore.fetchModalDatasources();

const tabletUp = breakpoints.greaterOrEqual('lg'); // only larger than sm

onMounted(() => {
  // Add scrollspy attributes to the following SXA components
  const sxaComponents = ['advice', 'insurance-and-roadside'];
  sxaComponents.forEach((id) => addToElement(id, '.snippet', 'data-scrollspy-id'));
});

/**
 * Helper function to add specific attributes to components
 * that live outside the Vue application.
 */
function addToElement(id: string, targetEl: string, attr: string) {
  const components = Array.from(document.querySelectorAll(targetEl));
  const matchingEl = components.find((el) => el.id.toLowerCase() === id.toLowerCase());

  matchingEl?.setAttribute(attr, id);
}
</script>

<style lang="scss" scoped>
.car-comparison-cart--active {
  padding-bottom: 12rem;
  //
}

.module-title {
  padding-top: 1.5rem;
  margin-bottom: 0;
  font-weight: bold;
  font-size: 2rem;
  line-height: 2.625rem;

  @media screen and (min-width: #{$breakpoint-md}) {
    padding-top: 2rem;
  }

  @media screen and (min-width: #{$breakpoint-xl}) {
    margin-bottom: 1rem;
    font-size: 2.625rem;
    line-height: 3rem;
  }
}

.module-subtitle {
  margin-top: -1rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
}
</style>
